import React from 'react';
import ReactDOM from 'react-dom';
import { Buffer } from 'buffer';
import { BrowserRouter } from 'react-router-dom';
import App from './components/App/App';
import './styles/index.scss';

// Shim Buffer globally so Swagger UI dependencies can use Node's Buffer in the browser
(window as any).Buffer = (window as any).Buffer || Buffer;

ReactDOM.render(
  <BrowserRouter>
  <App />
  </BrowserRouter>,
  document.getElementById('root')
);
